import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Dayjs from 'dayjs';
import zh from 'dayjs/locale/zh-cn';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import utils from '@/utils'; // import data from '@/components/d2-icon-select/data/index'
// import timezone from 'dayjs/plugin/timezone'

var customizedLocale = _objectSpread(_objectSpread({}, zh), {}, {
  meridiem: function meridiem(hour, minute, isLowercase) {
    return hour > 12 ? '下午' : '上午';
  }
});

Dayjs.locale(customizedLocale);
Dayjs.extend(LocalizedFormat);
Dayjs.extend(relativeTime);
Dayjs.extend(utc); // Dayjs.extend(timezone)
// console.log(Dayjs.locale()) // 'en'
// console.log(Dayjs.tz.guess()) // America/Chicago
// let datetime = Dayjs('2020-11-08 15:00').tz(Dayjs.tz.guess()).format('ddd, DD MMM YYYY HH:mm')
// console.log(datetime)
// datetime = Dayjs('2020-11-08 15:00').tz('America/Chicago').format('ddd, DD MMM YYYY HH:mm')
// console.log(datetime)
// Dayjs.tz.setDefault(Dayjs.tz.guess())

export var dayjs = Dayjs;
export function format(value) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY年M月D日';
  var currentValue = value;

  if (!dayjs.isDayjs(value)) {
    if (dayjs(value).isValid()) {
      currentValue = dayjs(value);
    } else {
      currentValue = {
        format: function format() {
          return '';
        }
      };
    }
  }

  return currentValue.format(config);
}

function getLocalTime(time) {
  // var i = utils.cookies.get('TimeZoneNN')?utils.cookies.get('TimeZoneNN')*1:8
  var i = utils.db.dbGet({
    dbName: 'sys',
    path: 'api.time',
    defaultValue: '8',
    user: false
  });
  var d = new Date(time.replace(' GMT', '')); // var d = new Date(time);
  //得到1970年一月一日到现在的秒数
  // console.log(time,"正常时间")
  // console.log(date)
  // console.log(d,i)

  var len = d.getTime(); //本地时间与GMT时间的时间偏移差(注意：GMT这是UTC的民间名称。GMT=UTC）

  var offset = d.getTimezoneOffset() * 60000; //得到现在的格林尼治时间

  var utcTime = len + offset;
  return new Date(utcTime + 3600000 * i);
}

export function format1(aa) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY年M月D日';

  if (aa) {
    var value = getLocalTime(aa); // console.log(value,"((((((((666")

    if (value) {
      var date = new Date(value); // 时间戳为10位需*1000
      // console.log(date,"((((((((((((77")

      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate() + ' ';
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      var result = Y + M + D + h + m + s; //  console.log(result,"((((((((((((88")
      // return result

      return format(result, config); // return Dayjs(result).tz('America/Chicago').format('YYYY-MM-DD HH:mm:ss')
    }
  } else {
    return '';
  }
}
export function format2(value, timezone) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'YYYY年M月D日';

  // 时区转换
  if (value) {
    var date = new Date(value.replace(' GMT', '')); // 时间戳为10位需*1000

    if (!timezone) {
      timezone = utils.cookies.get('time_zone');
    }

    date.setHours(date.getHours() + parseInt(timezone));
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate() + ' ';
    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    var result = Y + M + D + h + m + s; // return result

    return format(result, config); // return Dayjs(result).tz('America/Chicago').format('YYYY-MM-DD HH:mm:ss')
  }

  return '';
}
export function getLocalDate(shijianchuo) {
  var instance = new Date(shijianchuo); // 创建一个Date对象

  var localTime = instance.getTime();
  var localOffset = instance.getTimezoneOffset() * 60000; // 获得当地时间偏移的毫秒数

  var utc = localTime + localOffset; // utc即GMT时间

  var offset = 8; // 东8区

  var beijing = utc + 3600000 * offset;
  return new Date(beijing);
} // // 目标时区，东9区
// let targetTimezone = -9
// // 当前时区与中时区时差，以min为维度
// let _dif = new Date().getTimezoneOffset()
// // 本地时区时间 + 时差  = 中时区时间
// // 目标时区时间 + 时差 = 中时区时间
// // 目标时区时间 = 本地时区时间 + 本地时区时差 - 目标时区时差
// // 东9区时间
// let east9time = new Date().getTime() + _dif * 60 * 1000 - (targetTimezone * 60 * 60 * 1000)
// new Date(east9time)
// var bjTimestamp = 1584027168;
// var localTimezoneMinutes = 420; // 每个时区间隔1小时，转换为分钟就是60，420也就是东七区，60 * 7 = 420，而480就表示东八区转换为秒为28800
// var localTime = dayjs((bjTimestamp + (localTimezoneMinutes - 480) * 60) * 1000).format('YYYY-MM-DD');
// 计算当地时间
// utc时间，世界调整时，就是各个时区的时间不一样，像北京时间是8点，那东京时间就是9点，比我们多了一个时区。之所以要转换时间，是因为手机时间会根据时区自动调整，假如我们坐一个航班8点出发到东京2个小时，我们手机当时看是10点到达，如果你到了东京手机上显示的时间应该是11点到达。

export function calcLocalTime(bjTimestamp, localTimezoneMinutes, format) {
  if (bjTimestamp && localTimezoneMinutes) {
    return dayjs(bjTimestamp * 1000).utcOffset(localTimezoneMinutes).format(format || 'YYYY-MM-DD HH:mm');
  }

  return '--';
} // calcLocalTime(1584027168, 420);